import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
    id: null,
    name: null,
    message: null
};

class JourneyNotification extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(JourneyNotification, json, {
            id: fields.number,
            name: fields.string,
            message: fields.string
        });
    }
}

export default JourneyNotification;
